import React, { useState } from "react";
import {
  Form,
  Input,
  Button,
  Upload,
  Avatar,
  Row,
  Col,
  message,
  Spin,
  Icon,
  Modal,
} from "antd";
import TextArea from "antd/lib/input/TextArea";
import { platformApi } from "../../../../../api";
import axios from "axios";

const Details = (props) => {
  const { data, setData, phone, loading, setLoading, modifyAccess } = props;
  const [webData, setWebData] = useState(data.websites[0] || "");
  const [imgLoad, setImgLoad] = useState(false);
  const [edit, setEdit] = useState(false);
  const [imageUrl, setImageUrl] = useState(data.image || null);
  const [hovered, setHovered] = useState(false);
  const [previewVisible, setPreviewVisible] = useState(false);

  let clload = null;

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    const values = data;
    values["websites"] = [webData];

    platformApi
      .patch("/api/whatsapp/update", values)
      .then((res) => {
        if (res.data.response.code === 200) {
          message.success("Updated successfully");
        } else {
          message.error("Updatation Failed");
        }
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        message.error("Updatation Failed");
      });
  };

  const beforeUpload = (file) => {
    // image type check
    const isJpgOrPng =
      file.type === "image/jpeg" ||
      file.type === "image/jpg" ||
      file.type === "image/png";
    if (!isJpgOrPng) {
      message.error("You can only upload JPG/PNG file!", 3);
      return false;
    }

    // image size check
    const isLt2M = file.size / 1024 / 1024 < 10;
    if (!isLt2M) {
      message.error("Image must smaller than 10MB!", 3);
      return false;
    }

    return true;
  };

  const customRequest = (options) => {
    const { file, onSuccess, onError } = options;
    setImgLoad(true);
    getBase64(file, (baseUrl) => {
      const formData = new FormData();
      formData.append("file", file);

      platformApi
        .post("/api/whatsapp/uploadProfile", formData)
        .then((res) => {
          if (res.data.code === 200) {
            const returnedUrl = res.data.response?.data?.Location || res.data.response?.data?.profile_picture_url || baseUrl;
            setImageUrl(returnedUrl);
            setData({ ...data, image: returnedUrl });
            message.success("Profile picture uploaded success", 2);
            if (onSuccess) onSuccess("ok");
          } else {
            message.error("Profile picture uploaded Failed", 2);
            if (onError) onError("failed");
          }
          setImgLoad(false);
        })
        .catch(() => {
          setImgLoad(false);
          message.error("something went wrong", 2);
          if (onError) onError("failed");
        });
    });
  };

  const handleDelete = () => {
    setImgLoad(true);
    platformApi
      .delete("/api/whatsapp/deleteProfile")
      .then((res) => {
        if (res.data.response?.code === 200 || res.data.code === 200) {
          setImageUrl(null);
          message.success("Profile picture deleted successfully");
        } else {
          message.error("Failed to delete profile picture");
        }
        setImgLoad(false);
      })
      .catch((err) => {
        setImgLoad(false);
        message.error("Failed to delete profile picture");
      });
  };

  const getBase64 = (img, callback) => {
    const reader = new FileReader();
    reader.addEventListener("load", () => callback(reader.result));
    reader.readAsDataURL(img);
  };

  return (
    <div className="whatsapp_details">
      <div className="whatsapp_details_profile_photo">
        <Form layout="inline" className="whatsapp_details_photo">
          <Form.Item
            name="Profile Picture"
            label="Profile Picture"
            colon={false}
            style={{ fontWeight: "bold" }}
          ></Form.Item>

          {imageUrl ? (
            <div
              style={{ position: "relative", width: 128, height: 128 }}
              onMouseEnter={() => setHovered(true)}
              onMouseLeave={() => setHovered(false)}
            >
              <Avatar
                shape="square"
                style={{ border: ".5px solid #00000020" }}
                size={128}
                src={imageUrl}
              />
              {hovered && (
                <div
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: 128,
                    height: 128,
                    backgroundColor: "rgba(0, 0, 0, 0.6)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "16px",
                    borderRadius: "4px",
                    zIndex: 10,
                  }}
                >
                  <Icon
                    type="eye"
                    style={{ color: "#fff", fontSize: "20px", cursor: "pointer" }}
                    onClick={() => setPreviewVisible(true)}
                  />
                  {modifyAccess && edit && (
                    <Icon
                      type="delete"
                      style={{ color: "#ff4d4f", fontSize: "20px", cursor: "pointer" }}
                      onClick={handleDelete}
                    />
                  )}
                </div>
              )}
            </div>
          ) : (
            <Upload
              name="avatar"
              listType="picture"
              showUploadList={false}
              beforeUpload={(e) => beforeUpload(e)}
              customRequest={customRequest}
              disabled={!modifyAccess}
            >
              <div style={{ display: "flex" }}>
                {imgLoad && (
                  <Spin
                    style={{
                      position: "absolute",
                      alignSelf: "center",
                      left: "22%",
                      zIndex: "2",
                    }}
                    size="large"
                    indicator={<Icon type="loading" />}
                  />
                )}
                <Avatar
                  shape="square"
                  style={{ cursor: modifyAccess ? "pointer" : "default", border: ".5px solid #00000020" }}
                  size={128}
                  icon="user"
                />
              </div>
            </Upload>
          )}
        </Form>
      </div>

      <Modal
        visible={previewVisible}
        footer={null}
        onCancel={() => setPreviewVisible(false)}
      >
        <img alt="Profile Preview" style={{ width: "100%" }} src={imageUrl} />
      </Modal>

      <Form>
        <Row>
          <Col span={8}>
            <Form.Item name="Phone Number" label="Phone Number" colon={false}>
              <Input
                value={data.number}
                placeholder="Enter the Phone Number"
                disabled={true}
              />
            </Form.Item>
          </Col>
          <Col span={8} style={{ marginLeft: "30px" }}>
            <Form.Item name="Email" label="Email" colon={false}>
              <Input
                value={data.email}
                name="email"
                placeholder="Email"
                disabled={!edit}
                onChange={(e) =>
                  setData({ ...data, [e.target.name]: e.target.value })
                }
              />
            </Form.Item>
          </Col>
        </Row>

        <Row>
          <Col span={8}>
            <Form.Item
              name="Business Address"
              label="Business Address"
              colon={false}
            >
              <Input
                value={data.address}
                disabled={!edit}
                name="address"
                placeholder="Business Address"
                onChange={(e) =>
                  setData({ ...data, [e.target.name]: e.target.value })
                }
              />
            </Form.Item>
          </Col>
          <Col span={8} style={{ marginLeft: "30px" }}>
            <Form.Item name="Website" label="Website" colon={false}>
              <Input
                value={webData}
                disabled={!edit}
                onChange={(e) => setWebData(e.target.value)}
              />
            </Form.Item>
          </Col>
        </Row>

        <Row>
          <Col span={15}>
            <Form.Item name="description" label="Description" colon={false}>
              <TextArea
                name="description"
                value={data.description}
                autosize={{ minRows: 3 }}
                placeholder="Description"
                disabled={!edit}
                onChange={(e) =>
                  setData({ ...data, [e.target.name]: e.target.value })
                }
              />
            </Form.Item>
          </Col>
        </Row>

        <Row type="flex" justify="end">
          <Col>
            {edit && <Button onClick={() => setEdit(false)}>Cancel</Button>}
            {modifyAccess && (
              <Button
                onClick={edit ? handleSubmit : () => setEdit(true)}
                type="primary"
                style={{ marginLeft: "1rem" }}
              >
                {edit ? "Save" : "Modify"}
              </Button>
            )}
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default Details;
